// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3UuPS","balanceDisclaimer":"posDashboard_balanceDisclaimer__35dMq"};